import { useRef } from "react"
import { getAnimateDelay } from "../../../utils/getAnimateDelay"
import { IFloatContainerProps } from "./FloatContainer"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"

const FloatAnimateContainer = ({float, ...props}: IFloatContainerProps ) : JSX.Element => { 
    const animated          = Array.isArray(float.animated ) 
        ?
        float.animated[ props.i % float.animated.length ] 
        :
        float.animated 
    const animated_delay    = getAnimateDelay(props.animated_delay, props.i) 
    const ref               = useRef(null)
    useAnimated( ref, animated_delay )

    const animate   = useAnimatedStyle(props, props.i)
    return <div className={`landing-float-animate ${ animate } float-${float.id} `} ref={ref}>
        {props.children }
    </div>
}

export default FloatAnimateContainer